export interface TronWebProvider {
    fullHost: string;
    headers?: Record<string, string>;
}
